import moment from 'moment';
import mqtt from 'mqtt';

let mClient = null;

export const mqttHandler = (params) => {
  const usageId = typeof params !== "undefined" && typeof params['usageId'] !== "undefined" ? params['usageId'] : '';

  const subscribeToTopics = (list) => {
    return new Promise((resolve, reject) => {
      mClient.subscribe(list, (err) => {
        if (err) {
          return reject(err);
        }

        resolve();
      });
    });
  };

  const mqttMessageHandler = (topic, message, packet, callbacks) => {
    const msg = message.toString();

    if (typeof callbacks !== 'undefined') {
      if (packet.retain) {
        if (typeof callbacks['onRetainMessage'] === 'function') {
          callbacks['onRetainMessage'](topic, msg);
        }
      } else {
        if (typeof callbacks['onMessage'] === 'function') {
          callbacks['onMessage'](topic, msg);
        }
      }
    }
  };

  return new Promise((resolve, reject) => {
    if (!params || !params.url || !params.username || !params.password) {
      return reject({
        statusCode: 400,
        message: 'Invalid broker params'
      });
    }

    mClient = mqtt.connect(params.url, {
      clientId: usageId + '_' + moment().format('X'),
      username: params.username,
      password: params.password,
      reconnectPeriod: 5000
    });

    let messageListenerAdded = false;

    mClient.on('connect', () => {
      if (!messageListenerAdded) {
        mClient.on('message', (topic, message, packet) => {
          const callbacks = {
            onRetainMessage: params['onRetainMessage'],
            onMessage: params['onMessage']
          };
          mqttMessageHandler(topic, message, packet, callbacks);
        });

        messageListenerAdded = true;
      }

      subscribeToTopics(params.topics);

      if (typeof params['onConnect'] === 'function') {
        params['onConnect']();
      }

      resolve();
    });

    mClient.on('close', () => {
      if (params && typeof params['onClose'] === 'function') {
        params['onClose']();
      }
    });
  });
};

export const mqttPublish = (topic, message) => {
  return new Promise((resolve, reject) => {
    if (!mClient) {
      return reject({
        statusCode: 500,
        message: 'MQTT connection not available'
      });
    }

    const msg = message.toString();

    mClient.publish(topic, msg, {}, (err) => {
      if (err) {
        return reject(err);
      }

      /* eslint-disable */
      console.log('Publish:', topic, ' -> ', msg);

      resolve();
    });
  });
};